import { useBusiness } from '@/contexts/BusinessContext'

/** The storefront's public URL (custom domain first), or null before one is set up. */
export const useStorefrontUrl = () => {
  const { profile } = useBusiness()
  const host = profile?.custom_customer_domain || profile?.platform_customer_domain
  return host ? `https://${host}` : null
}
